import { Component, input, output } from '@angular/core';

@Component({
  selector: 'lib-text-input',
  templateUrl: './text-input.component.html',
})
export class TextInputComponent {
  public readonly label = input<string>();

  public readonly inputId = input<string>();

  public readonly type = input<'text' | 'number'>('text');

  public readonly value = input<string>();

  public readonly placeholder = input<string>();

  public readonly readonly = input(false);

  public readonly changed = output<string>();

  applyValue(event: Event): void {
    this.changed.emit((event.target as HTMLInputElement).value);
  }
}
